import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { TEXTURE_FILTER_TYPE } from '../constants/constants';
import { useFilterDropdownOptions } from '../hooks/useFilterDropdownOptions';
import {
  selectTextureDetailsModalData,
  textureDetailsModalActions,
} from '../redux/slicers/textureDetailsModalSlicer';
import { icons } from '../assets';
import { useRefreshFilter } from '../hooks/useFetchAllFilters';
import { convertCMToActiveUnits } from '../helpers/curatorActions';
import { selectActiveMeasureUnitsName } from '../redux/slicers/admin/curatorSlicer';
import { MEASURE_UNIT_LABEL } from '../config/constant/unityConstants';
const { CloseIconSmall } = icons;

export const TextureDetailsModal = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectTextureDetailsModalData);
  const open = Boolean(data);

  const onClose = () => {
    dispatch(textureDetailsModalActions.close());
    console.log("TextureDetailsModalUI")
  };

  useEffect(() => {
    return () => dispatch(textureDetailsModalActions.close());
  }, []);

  if (!open) return null;

  return <TextureDetailsModalUI onClose={onClose} data={data} open={open} />;
};

export const TextureDetailsModalUI = ({ open, onClose, data }) => {
  const measureUnits = useSelector(selectActiveMeasureUnitsName);
  const textureFilters = useFilterDropdownOptions({
    filterType: TEXTURE_FILTER_TYPE,
    fetchData: true,
  });

  let fiterOptionIdList = [];
  if (Array.isArray(data.filteroptions)) {
    // filteroptions might be list of ids or list of filter options
    fiterOptionIdList =
      typeof data.filteroptions[0] === 'object'
        ? data.filteroptions.map((option) => option.id)
        : data.filteroptions;
  }

  const hasSkuId =
    (typeof data.sku_id === 'string' && data.sku_id.trim() !== '') ||
    typeof data.sku_id === 'number';

  const getTextureSizeInCurrentUnit = (_unit) =>  {
    return `${parseFloat(convertCMToActiveUnits(_unit)).toFixed(2)} ${MEASURE_UNIT_LABEL[measureUnits]}`}

  return (
    <Offcanvas
      className="rightSidebar leaveHeader texture-details"
      show={open}
      onHide={onClose}
      placement={'end'}
      name={'end'}
      backdropClassName="hideBackdrop"
      >
      <Offcanvas.Header className="align-items-top sidebarHeader">
        <Offcanvas.Title className="fullWidth">
          <div className="heading-user-title">
            <h4 className="m-0 ellipsis">{data.name}</h4>
            <label className="fullWidth ellipsis light">
              {hasSkuId && (
                <>
                Sku ID - <span>{data.sku_id}</span>
                </>
              )}
            </label>
          </div>
        </Offcanvas.Title>
        <Button className="modalCloseButton textureCloseButton" onClick={onClose}>
          <CloseIconSmall width={17} height={17} />
        </Button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* <Col>
        </Col> */}
        <div className="image-part">
          <img src={data.thumbnail} alt="texture_image" />
        </div>
        <div className="texture-info after-line">
          <h6>Texture Detail</h6>
          <p className="d-flex justify-content-between gap-1">
            <span>
              Width: {getTextureSizeInCurrentUnit(data.width)} &times; Height:{' '}
              {getTextureSizeInCurrentUnit(data.height)}
            </span>
            <span>Rotation: {parseFloat(data.rotation)}</span>
          </p>
        </div>
        {data.description && (
          <div className="texture-info after-line">
            <h6>Description</h6>
            <p>{data.description}</p>
          </div>
        )}

          {!isEmpty(fiterOptionIdList) &&
            textureFilters.map((filter) => {
              const options = filter.options.filter((o) => fiterOptionIdList.includes(o.value));
              if (!options.length) return null;
              return (
                <div className="texture-info after-line" key={filter.id}>
                  <h6>{filter.label_name}</h6>
                  <p className="label-part">
                    {options.map((option) => (
                      <span key={option.value} className="label label-category">
                        {option.label}
                      </span>
                    ))}
                  </p>
                </div>
              );
            })}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
